import React from 'react';
import { BsFacebook, BsInstagram, BsYoutube } from "react-icons/bs";
import { css } from "@emotion/react";
import theme from "../../theme";

const SocialButtons = () => {
    return (
        <div css={socialIconsContainerStyle}>
            <a
                href={"https://www.facebook.com/writerstoolbox"}
                css={socialIconWrapperStyle}
            >
                <BsFacebook css={socialIconStyle} />
            </a>
            <a
                href={"https://www.instagram.com/writerstoolbox"}
                css={socialIconWrapperStyle}
            >
                <BsInstagram css={socialIconStyle} />
            </a>
            <a
                href={"http://www.youtube.com/c/WritersToolbox/"}
                css={socialIconWrapperStyle}
            >
                <BsYoutube css={socialIconStyle} />
            </a>
        </div>
    )
}

export default SocialButtons;


const socialIconStyle = css`
    width: 20px;
    height: 20px;
    fill: white;
`;

const socialIconsContainerStyle = css`
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 50px;
`;

const socialIconWrapperStyle = css`
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color: ${theme.colours.grey[650]};
    display: flex;
    align-items: center !important;
    justify-content: center;
    transition: background-color ${theme.transitions.transitionFaster};

    a {
        width: 20px;
        height: 20px;
    }

    &:not(:last-of-type) {
        margin-right: 10px;
    }

    &:hover {
        background-color: ${theme.colours.grey[800]};
    }
`;